import React from "react";
import { useTranslate } from "@refinedev/core";
import { PillTabs, type PillTab } from "../PillTabs";
import { analyticsTheme } from "../analyticsTheme";
import { ADDON_COLORS, type VisibleAddon } from "./utils/metrics";

export const OVERVIEW_PILL = "overview";
export const VIDEO_PILL = "video";
const OVERVIEW_COLOR = "#9399a6";

export type AddonPillsProps = {
  addons: VisibleAddon[];
  /** Whether the project has a video, which gets a pill of its own. */
  hasVideo: boolean;
  activeKey: string;
  onChange: (key: string) => void;
};

/** Add-ons tab navigation: the overview, the video, then each add-on. */
export const AddonPills: React.FC<AddonPillsProps> = ({
  addons,
  hasVideo,
  activeKey,
  onChange,
}) => {
  const t = useTranslate();
  const pills: PillTab[] = [
    {
      key: OVERVIEW_PILL,
      label: t("media.projects.analytics.addons.pills.overview"),
      color: OVERVIEW_COLOR,
    },
    ...(hasVideo
      ? [
          {
            key: VIDEO_PILL,
            label: t("media.projects.analytics.tabs.video"),
            color: analyticsTheme.datasetGreen,
          },
        ]
      : []),
    ...addons.map((a) => ({
      key: a.addon,
      label: t(`media.projects.analytics.addons.names.${a.addon}`),
      color: ADDON_COLORS[a.addon],
    })),
  ];
  return <PillTabs tabs={pills} activeKey={activeKey} onChange={onChange} />;
};
